letterAdjust.scale = 0.8;
var font = {
  "'": "M159,846l0,219H0l0-219L159,846z",
  "-": "M0,611V452h378v159H0z",
  ".": "M0,159V0h159v159H0z",
  "0": "M0 138v787l135 140h321l135 -140v-787l-135 -138h-321zM178 185h233v695h-233v-695z",
  "1": "M0 0v185h99v695h-99v185h278v-880h99v-185h-377z",
  "2": "M0 0v488l133 137h278v255h-233v-114h-178v159l133 140h323l134 -140v-347l-134 -137h-278v-256h233v115h179v-300h-590z",
  "3": "M0 138v162h179v-115h232v256h-180v184h180v255h-232v-114h-179v159l133 140h322l137 -140v-321l-73 -72l73 -71v-323l-137 -138h-322z",
  "4": "M0 527l366 538h186v-562h97v-185h-97v-133h97v-185h-373v185h98v133h-310zM201 503h173v253z",
  "5": "M0 138v162h178v-115h233v273h-278l-133 139v468h590v-185h-412v-237h278l134 -140v-365l-134 -138h-323z",
  "6": "M0 138v787l133 140h323l134 -140v-159h-177v114h-234v-255h277l134 -137v-350l-134 -138h-323zM179 185h234v256h-234v-256z",
  "7": "M0 0v185h98l376 695h-240v-114h-177v299h470l165 -160l-390 -720h76v-185h-378z",
  "8": "M0 138v323l71 71l-71 72v321l135 140h321l135 -140v-321l-69 -72l69 -71v-323l-135 -138h-321zM178 185h233v256h-233v-256zM178 625h233v255h-233v-255z",
  "9": "M0 138v160h178v-113h233v254h-276l-135 140v347l135 139h320l136 -139v-788l-136 -138h-320zM178 625h233v254h-233v-254z",
  "A": "M0 0h160l28 176h160l26 -176h160l-171 1065h-191zM213 332l55 335l54 -335h-109z",
  "B": "M0 0h402l132 133v329l-78 78l78 80v312l-132 133h-402v-1065zM159 159v303h219v-303h-219zM159 620v287h219v-287h-219z",
  "C": "M0 133l133 -133h266l135 133v199h-157v-173h-221v748h221v-144h157v169l-135 133h-266l-133 -133v-799z",
  "D": "M0 0h399l135 133v799l-135 133h-399v-1065zM156 159v748h221v-748h-221z",
  "E": "M0 0h534v159h-378v293h221v159h-221v296h378v158h-534v-1065z",
  "F": "M0 0h159v452h219v159h-219v296h375v158h-534v-1065z",
  "G": "M0 133l133 -133h269l132 133v357h-266v-158h109v-173h-221v748h221v-144h157v169l-132 133h-269l-133 -133v-799z",
  "H": "M0 0h156v452h222v-452h156v1065h-156v-454h-222v454h-156v-1065z",
  "I": "M0 0h159v1065h-159v-1065z",
  "J": "M0 133l133 -133h269l132 133v932h-157v-906h-221v173h-156v-199z",
  "K": "M0 0h159v445l25 43l182 -488h168l-248 658l248 407h-185l-190 -318v318h-159v-1065z",
  "L": "M0 0h418v159h-262v906h-156v-1065z",
  "M": "M0 0h156v620l112 -290l110 290v-620h156v1065l-156 -2l-110 -287l-112 287l-156 2v-1065z",
  "N": "M0 0h159v604l218 -604h157v1065h-157v-604l-218 604h-159v-1065z",
  "O": "M0 133l133 -133h269l132 133v799l-132 133h-269l-133 -133v-799zM159 159v748h218v-748h-218z",
  "P": "M0 0h159v404h243l132 132v396l-132 133h-402v-1065zM159 563v344h219v-344h-219z",
  "Q": "M0 132l132 -132h174l53 -100h132l-64 125l108 107v801l-133 132h-270l-132 -132v-801zM159 157v750h219v-750h-219z",
  "R": "M0 0h159v404h76l134 -404h165l-135 404l135 132v396l-132 133h-402v-1065zM159 563v344h219v-344h-219z",
  "S": "M0 133l135 -133h267l132 133v357l-132 130h-243v287h219v-144h156v169l-132 133h-267l-135 -133v-335l135 -135h243v-303h-219v173h-159v-199z",
  "T": "M0 907h188v-907h156v907h190v158h-534v-158z",
  "U": "M0 133l133 -133h269l132 133v932h-156v-906h-219v906h-159v-932z",
  "V": "M0 1065l172 -1065h189l173 1065h-160l-106 -667l-108 667h-160z",
  "W": "M0 1065l85 -1065h143l77 393l76 -393h142l85 1065h-158l-35 -429l-83 429h-55l-84 -429l-37 429h-156z",
  "X": "M0 0h168l100 290l98 -290h168l-182 532l182 533h-168l-98 -290l-100 290h-168l185 -533z",
  "Y": "M0 1065l188 -529v-536h155v536l188 529h-166l-100 -280l-97 280h-168z",
  "Z": "M0 177l51 -177h432l36 159h-355l367 729l-61 177h-421l-37 -158h353z"
};

// Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
var font_size = 26,
    panel_Hor_Adjustment = 2,
    tracking = 3,
    font_Top_Adjustment = -18,
    small_Caps_Adjustment = {
    vertical: -230,
    horizontal: 0,
    scale_width: 0,
    scale_height: 0,
    },
    colors = {
    characters: {
      home: [
      "#99d9d9"
      ],
      away: [
      "#051c2c"
      ]
    },
    numbers: {
      home: [
      "#99d9d9",
      "#68a2b9",
      ],
      away: [
      "#051c2c",
      "#68a2b9"
      ]
    }
    },
    outlines = {
    characters: {
      width: 0
    },
    numbers: {
      width: 3
    }
    }
    special_Character_Adjustments = {
    period: {
        vertical: 2.5, // this moves it up from the bottom
        horizontal: 0,
        scale_width: 40,
        scale_height: 40,
      },
      hyphen: {
        vertical: 6, // moves hyphen up
        horizontal: -4.5,
        scale_width: 0,
        scale_height: 0,
      },
      apostrophe: {
        vertical: -19.5,
        horizontal: 0.5,
        scale_width: 12,
        scale_height: 23,
      }
    },
    number_Adjustments = {
      top: 15,
      left: -5,
      width: 120,
      height: 97,
      middle_Space: 5,
    };